export default "__VITE_ASSET__BSIoHEOI__"